import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: 'Início', href: '#hero' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Consultoria Jurídica', href: '#consultoria' },
  { label: 'Atuação', href: '#diferenciais' },
  { label: 'Contato', href: '#contato' },
];

const WHATSAPP_URL = 'https://wa.me/5579999778899?text=Olá,%20gostaria%20de%20agendar%20uma%20consulta%20jurídica.';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const offset = 80;
      const top = (el as HTMLElement).getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#1F4B63] shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/f1b3a4175f8a22f2b553a2df5776ff9e.png"
            alt="Diogo de Calasans Melo Andrade – Advocacia"
            className="h-[76px] w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="text-sm font-500 tracking-wide transition-colors duration-200 relative group cursor-pointer whitespace-nowrap text-white"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#C6935A] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        {/* CTA Button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:flex items-center gap-2 bg-[#C6935A] hover:bg-[#A8763F] text-white text-sm font-600 px-6 py-3 rounded-full transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap"
        >
          <i className="ri-whatsapp-line text-base" />
          Falar no WhatsApp
        </a>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-white"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`lg:hidden fixed inset-0 bg-[#173A4D] z-40 flex flex-col items-center justify-center gap-10 transition-all duration-400 ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        style={{ top: 0 }}
      >
        <button
          className="absolute top-5 right-6 text-white text-3xl cursor-pointer w-10 h-10 flex items-center justify-center"
          onClick={() => setMenuOpen(false)}
        >
          <i className="ri-close-line" />
        </button>
        {NAV_ITEMS.map((item) => (
          <a
            key={item.href}
            href={item.href}
            onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
            className="text-white text-2xl font-500 tracking-wide hover:text-[#C6935A] transition-colors cursor-pointer"
          >
            {item.label}
          </a>
        ))}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-[#C6935A] text-white text-base font-600 px-8 py-4 rounded-full mt-4 whitespace-nowrap"
        >
          <i className="ri-whatsapp-line" />
          Falar no WhatsApp
        </a>
      </div>
    </header>
  );
}
